var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomPage',{attrs:{"title":"关于我们"}},[_c('div',{staticClass:"content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"about-us-html",domProps:{"innerHTML":_vm._s(_vm.html)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }